
import api from '../api';

export const deleteEngagement = async (engagementId) => {
  const res = await api.delete(`/engagements/${engagementId}`);
  return res.data;
};

export const getReports = async (projectId, formGroupId) => {
  const res = await api.get(`/engagements/reports`, { params: { projectId, formGroupId } });
  return res.data;
};

// Validate an engagement
export const validateEngagement = async (engagementId) => {
  const res = await api.post(`/engagements/${engagementId}/validate`);
  return res.data;
};

// Reject an engagement with a remark
export const rejectEngagement = async (engagementId, remark) => {
  const res = await api.post(`/engagements/${engagementId}/reject`, { remark });
  return res.data;
};

// Update engagement status (validate or reject)
export const updateEngagementStatus = async (engagementId, status, remarksField, remarks) => {
  const body = { status };
  body[remarksField] = remarks || '';
  const res = await api.patch(`/engagements/${engagementId}/status`, body);
  return res.data;
};

// Fetch engagement dashboard data
export const fetchEngagementDashboard = async (filters, forceRefresh = false) => {
  const params = new URLSearchParams();

  if (filters.from) params.append('from', filters.from);
  if (filters.to) params.append('to', filters.to);
  if (forceRefresh) params.append('forceRefresh', 'true');

  const res = await api.get(`/projects/${filters.projectId}/users/dashboard?${params.toString()}`);
  return res.data;
};